import { ProductOfferListItem } from 'types';
import { OfferSortingKey, SortDirection } from './utils';

// Helper function to handle APY sorting
const sortByAPY = (products: ProductOfferListItem[], sortDirection: SortDirection) =>
  [...products].sort((a, b) => {
    if (a.apy === b.apy) {
      return a.bankName.localeCompare(b.bankName);
    }
    const apyDifference = a.apy - b.apy;
    return sortDirection === 'desc' ? -apyDifference : apyDifference;
  });

// Helper function to handle maturity sorting
const sortByMaturity = (products: ProductOfferListItem[], sortDirection: SortDirection) =>
  [...products].sort((a, b) => {
    const maturityDifference = a.maturityDuration - b.maturityDuration;
    return sortDirection === 'desc' ? -maturityDifference : maturityDifference;
  });

// Helper function to handle generic string sorting
const sortByStringField = (
  products: ProductOfferListItem[],
  field: Exclude<OfferSortingKey, 'maturityDuration' | 'apy'>,
  sortDirection: SortDirection,
) =>
  [...products].sort((a, b) => {
    const aField = a[field] ?? '';
    const bField = b[field] ?? '';
    const comparison = aField.localeCompare(bField);
    return sortDirection === 'desc' ? -comparison : comparison;
  });

export const sortOffers = (
  products: ProductOfferListItem[],
  sortBy: OfferSortingKey,
  sortDirection: SortDirection,
  isSavingsOffer: boolean,
) => {
  switch (sortBy) {
    case 'apy':
      return sortByAPY(products, sortDirection);
    case 'maturityDisplay':
      if (!isSavingsOffer) {
        return sortByMaturity(products, sortDirection);
      }
      break;
    case 'productName':
    case 'bankName':
      return sortByStringField(products, sortBy, sortDirection);
    default:
      return products;
  }
  return products;
};
